import Vue from 'vue'
import VuePlyr from 'vue-plyr'
 
Vue.use(VuePlyr, {
  plyr: {
    controls: ['progress']
  }
})